import { Select } from '@amzn/awsui-components-react';
import { useLocalizedText } from '../../../hooks/localizedText';
import { ParticipationStatus, Amazonian } from '../../../utils/attendance/peopleSearch';

interface AttendanceSelectProps {
  participant: Amazonian;
  currentValue: string;
  onAttendanceChange: (status: ParticipationStatus) => void;
}

export const AttendanceSelect = (props: AttendanceSelectProps) => {
  const { currentValue, onAttendanceChange } = props;
  const { t } = useLocalizedText(['attendance', 'translation']);

  const ATTENDANCE_OPTIONS = [
    { label: t('coordinatorAttendeeTable.coordinatorTracking.setAttended'), value: 'ATTENDED' },
    {
      label: t('coordinatorAttendeeTable.coordinatorTracking.setDidNotAttend'),
      value: 'DID_NOT_ATTEND',
    },
  ] as const;

  return (
    <Select
      ariaLabel={t('coordinatorAttendeeTable.selectAttendance')}
      // Although a user's status can display as pending, we don't want users to be able to select a pending status
      placeholder={t('coordinatorAttendeeTable.coordinatorTracking.pending')}
      autoFocus={true}
      expandToViewport={true}
      options={ATTENDANCE_OPTIONS}
      selectedOption={ATTENDANCE_OPTIONS.find((option) => option.value === currentValue) ?? null}
      onChange={(event) => {
        onAttendanceChange(event.detail.selectedOption.value as ParticipationStatus);
      }}
    />
  );
};
